// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoLayout_wrapper__xESOF","icon":"InfoLayout_icon__oCl9E","body":"InfoLayout_body__wf3Jv","desc":"InfoLayout_desc__BsdJM"};